import 'css-chunk:src/components/styled-text/styled-text-component.module.scss';export default {
  "styled-text-component": "styled-text-component_styled-text-component__n1WQb",
  "text-size-sm": "styled-text-component_text-size-sm__OLOfR",
  "text-size-md": "styled-text-component_text-size-md__fX0TM",
  "text-size-lg": "styled-text-component_text-size-lg__TOEgi",
  "text-size-xl": "styled-text-component_text-size-xl__GZSL1",
  "text-size-xxl": "styled-text-component_text-size-xxl__ejq5J",
  "text-size-headline": "styled-text-component_text-size-headline__IX-bn",
  "text-size-paragraph": "styled-text-component_text-size-paragraph__tnHQY",
  "text-size-label": "styled-text-component_text-size-label__LIoys",
  "black": "styled-text-component_black__64GL3",
  "grey": "styled-text-component_grey__pkQjT",
  "white": "styled-text-component_white__Opn1f",
  "rsRed": "styled-text-component_rsRed__2tyfx",
  "darkRed": "styled-text-component_darkRed__Yg4x0",
  "highlightRed": "styled-text-component_highlightRed__CKRe6",
  "midtoneRed": "styled-text-component_midtoneRed__-i-uU",
  "shadowRed": "styled-text-component_shadowRed__nA9Vc",
  "humanRed": "styled-text-component_humanRed__J74XF",
  "purple": "styled-text-component_purple__rVjKJ",
  "darkPurple": "styled-text-component_darkPurple__-swhW",
  "mobile-black": "styled-text-component_mobile-black__-PzaX",
  "mobile-grey": "styled-text-component_mobile-grey__Cyn-T",
  "mobile-white": "styled-text-component_mobile-white__x6PeQ",
  "mobile-red": "styled-text-component_mobile-red__xIVhN",
  "mobile-darkRed": "styled-text-component_mobile-darkRed__ptJXa",
  "mobile-purple": "styled-text-component_mobile-purple__-zRLY",
  "mobile-darkPurple": "styled-text-component_mobile-darkPurple__FUSvt"
};